import React, { useState } from 'react';
import FadeIn from '../common/FadeIn';
import { HiArrowLongLeft, HiArrowLongRight } from 'react-icons/hi2';
import { reviewsData } from '../../data/reviewsData';

const ClientNotesSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? reviewsData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === reviewsData.length - 1 ? 0 : prevIndex + 1
    );
  };

  const currentReview = reviewsData[currentIndex];

  return (
    <section className="w-full bg-[#f9f9f5] py-12 sm:py-16 md:py-20 px-5 sm:px-8 md:px-12 lg:px-16 text-[#1C1917]">
      <div className="max-w-[1240px] mx-auto flex flex-col items-center text-center">

        <FadeIn className="w-full mb-1 md:mb-2">
          <div className="flex items-center justify-center text-[#8B8477]">
            <h3 className="font-interDisplayMedium leading-[1.6] tracking-[0.2em] md:text-[14px] uppercase">
              What My Clients Say
            </h3>
          </div>
        </FadeIn>

        <div className="w-full flex flex-col">

          <div className="order-2 lg:order-1 w-full max-w-[850px] mx-auto mt-8 lg:mt-0 mb-2 lg:mb-4">
            <FadeIn>
              <div className="w-full">
                <h2 className="font-saolDisplayItalic text-[30px] md:mb-[16px] md:text-[55px] font-normal tracking-[0em] leading-[1.2]">
                  {currentReview.title}
                </h2>
              </div>

              <div className="w-full h-[250px] md:h-[100px] text-[14px] leading-[1.7] font-normal tracking-[0em] flex items-center justify-center overflow-y-auto custom-scrollbar px-2">
                <p className="font-inter-display-medium max-w-[632px] mx-auto">
                  "{currentReview.quote}"
                </p>
              </div>

              <div className="w-full">
                <a
                  href={currentReview.link || "https://lightgoldenrodyellow-quetzal-387860.hostingersite.com/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-PromenadeItalic text-[24px] font-normal leading-[1.6] tracking-[0em] mb-[10px] md:mb-3 hover:opacity-80 transition-opacity cursor-pointer inline-block"
                >
                  {currentReview.author}
                </a>
              </div>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 w-full max-w-[1100px] mx-auto flex items-center justify-center">
            <FadeIn>
              <div className="flex flex-row items-center justify-center gap-3 sm:gap-5 md:gap-8 w-full mx-auto">

                <div className="w-[87px] h-[117px] sm:w-[150px] sm:h-[183px] md:w-[200px] md:h-[244px] lg:w-[250px] lg:h-[305px] xl:w-[289px] xl:h-[352px] flex-shrink-0 overflow-hidden rounded-sm bg-[#EFECE6] shadow-sm">
                  <img
                    src={currentReview.images.left}
                    alt="SeaSalt Creative Client Portfolio Showcase Left"
                    className="w-full h-full object-cover object-center"
                    loading="lazy"
                    decoding="async"
                    width="289"
                    height="352"
                  />
                </div>

                <div className="w-[105px] h-[139px] min-[375px]:w-[125px] min-[375px]:h-[163px] min-[425px]:w-[139px] min-[425px]:h-[185px] md:w-[281px] md:h-[286px] lg:w-[295px] lg:h-[398px] min-[1440px]:w-[346px] min-[1440px]:h-[419px] flex-shrink-0 overflow-hidden rounded-sm bg-[#EFECE6] shadow-md z-10">
                  <img
                    src={currentReview.images.center}
                    alt="SeaSalt Creative Client Portrait Center"
                    className="w-full h-full object-cover object-center"
                    loading="lazy"
                    decoding="async"
                    width="346"
                    height="419"
                  />
                </div>

                <div className="w-[87px] h-[117px] sm:w-[150px] sm:h-[183px] md:w-[200px] md:h-[244px] lg:w-[250px] lg:h-[305px] xl:w-[289px] xl:h-[352px] flex-shrink-0 overflow-hidden rounded-sm bg-[#EFECE6] shadow-sm">
                  <img
                    src={currentReview.images.right}
                    alt="SeaSalt Creative Client Portfolio Showcase Right"
                    className="w-full h-full object-cover object-center"
                    loading="lazy"
                    decoding="async"
                    width="289"
                    height="352"
                  />
                </div>

              </div>
            </FadeIn>
          </div>

        </div>

        <FadeIn className="w-full mt-6 md:mt-8">
          <div className="flex items-center justify-center gap-6 sm:gap-8">
            <button
              onClick={handlePrev}
              aria-label="Previous note"
              className="hover:text-[#1C1917] transition-colors cursor-pointer p-1"
            >
              <HiArrowLongLeft className="w-6 h-6 sm:w-8 sm:h-8 text-[#897e70]" />
            </button>
            <button
              onClick={handleNext}
              aria-label="Next note"
              className="hover:text-[#1C1917] transition-colors cursor-pointer p-1"
            >
              <HiArrowLongRight className="w-6 h-6 sm:w-8 sm:h-8 text-[#897e70]" />
            </button>
          </div>
        </FadeIn>

      </div>
    </section>
  );
};

export default ClientNotesSection;
